<template>
<div>
  <div class="wistia_embed wistia_async_4s6tq69dom">
    &nbsp;
  </div>

  <div
    id="captivate-choices"
    class="tbk-vid-embed"
  >
    <a
      id="captivate-biking"
      class="embedded_video"
      href="#wistia_63ux5xptoy?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="captivate-blind-beggar"
      class="embedded_video"
      href="#wistia_saugokrux8?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="captivate-ikaria"
      class="embedded_video"
      href="#wistia_wtdbtu2hbn?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="captivate-continue"
      class="embedded_video"
      href="#wistia_qjnf8wer28?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>
  </div>
</div>
</template>

<script>
import TbkVideoMixin from './TbkVideoMixin'

export default {
  mixins: [TbkVideoMixin],

  mounted() {
    this.tbk.loadCrossTime('4s6', 129, this.showSelect)
    this.tbk.loadCrossTime('63u', 77, this.showSelect)
    this.tbk.loadCrossTime('sau', 65, this.showSelect)
    this.tbk.loadCrossTime('wtd', 163, this.showSelect)

    if (this.tbk.isMobile()) {
      _wq.push({
        '63u': this.tbk.autoPlay,
        sau: this.tbk.autoPlay,
        wtd: this.tbk.autoPlay,
        qjn: this.tbk.autoPlay
      })
    }
  },

  methods: {
    showSelect() {
      $('.tbk-vid-embed').show()
      this.tbk.hideMobileControls()
    }
  }
}
</script>

<style scoped lang="sass">
#captivate-choices
  display: none
  a
    text-decoration: none
#captivate-biking
  position: absolute
  top: calc(100% * (134 / 360))
  left: calc(100% * (40 / 640))
  width: calc(100% * (160 / 640))
  height: calc(100% * (91 / 360))
#captivate-blind-beggar
  position: absolute
  top: calc(100% * (134 / 360))
  left: calc(100% * (239 / 640))
  width: calc(100% * (160 / 640))
  height: calc(100% * (91 / 360))
#captivate-ikaria
  position: absolute
  top: calc(100% * (134 / 360))
  left: calc(100% * (440 / 640))
  width: calc(100% * (160 / 640))
  height: calc(100% * (91 / 360))
#captivate-continue
  position: absolute
  top: calc(100% * (267 / 360))
  left: calc(100% * (228 / 640))
  width: calc(100% * (185 / 640))
  height: calc(100% * (28 / 360))
</style>
